import { Pipe, PipeTransform } from '@angular/core';
import * as Sentry from '@sentry/browser';

@Pipe({
  name: 'price',
  standalone: false
})
export class PricePipe implements PipeTransform {

  /**
   * @param value price to transform
   * @param currencyCode BCP 47 language code
   * @returns transformed price
   */
  public transform(value: number, currencyCode = 'CZK'): string {
    // todo get from locale?
    const localization = 'cs-CZ';

    // todo - when price reach some really high value (overflowing div etc) use [notation: "compact"]
    const formatOptions: Intl.NumberFormatOptions = {
      style: 'currency',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      currency: currencyCode,
    };

    // prevent IEEE 754 "-0" strings in view
    value = Object.is(Math.round(value), -0) ? 0 : value;

    try {
      return new Intl.NumberFormat(localization, formatOptions).format(value);
    } catch (error) {
      // used to debugg "Value negative out of range for Intl.NumberFormat options property signDisplay" error
      Sentry.addBreadcrumb({ data: { localization } });
      Sentry.addBreadcrumb({ data: { formatOptions } });
      Sentry.addBreadcrumb({ data: { value } });
      Sentry.addBreadcrumb({ data: { error } });
      Sentry.captureException('Debugg message: Failed to parse (1) following number:' + value);
      return value + '';
    }
  }
}
